import MmenuLight from 'mmenu-light';

const ua = window.navigator.userAgent;
const isIE = /MSIE|Trident/.test(ua);

// ignore for IE
if (!isIE) {
    const node = document.querySelector('.m-nav-mobile');

    if(node) {
        const menu = new MmenuLight(node, {
            title: 'Start',
            theme: 'dark',
            blockPage: false,
        });

        menu.enable('(max-width: 1139px)');
        menu.offcanvas();

        document.querySelector('.m-h-btn').addEventListener('click', () => {
            menu.open();
        });

        /*Close*/
        let tmp_search = document.querySelector('.m-ilink--search a');
        if (tmp_search) {
            tmp_search.addEventListener('click', () => menu.close());
        }
        document.querySelector('.m-nav-mobile__close').addEventListener('click', () => menu.close());

        /*Countries*/
        let tmp_countries = document.querySelector('.m-ilink--countries a');
        if (tmp_countries) {
            tmp_countries.addEventListener('click', () => {
                menu.openPanel(document.querySelector('.m-nav-mobile__countries > ul'));
            });
        }
        // document.querySelector('.m-nav-mobile__bottom-links-country').addEventListener('click', () => {
        //   menu.openPanel(document.querySelector('.m-nav-mobile__countries > ul'));
        // });
    }
}

